/**
 * Emv Terminal
 */

(function(global, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(global);
    }
})(typeof window !== 'undefined' ? window : this, function(window) {

var EmvTerminal = {

    /**
     * Add Token Store using EMV Terminal
     */
    tokenStoreAdd: function(userId) {

        var $dialogContent = jQuery(
            '<div><p class="pos-terminal-text">Please process payment through the EMV terminal.</p></div>'
        );

        var shift4LocalUtgUrl = jQuery('#call-emv-url').val();
        TakePayment.callTerminal(
            {
                shift4LocalUtgUrl: shift4LocalUtgUrl
            },
            function(data) {
                var url = '/payment/emv-terminal-token-store-add';

                data.user_id = userId;

                var myAjax = new Ajax.Request(
                    url,
                    {
                        parameters: data,
                        onComplete: function(request, div) {
                            var result = request.responseJSON;
                            $dialogContent.caDialog('close');
                            if (result.status === 0) {
                                jQuery.caAlert(result.error);
                                return false;
                            }
                            location.reload();

                        },
                        onFailure: reportAjaxError
                    }
                );

                $dialogContent.caDialog({
                    title:'Transaction In Progress...',
                    resizable:false,
                    width: 600,
                    showCloseButton:false,
                    modal : true
                });
            }
        );
    }
};

window.EmvTerminal = EmvTerminal;
});